<template>
  <div class="container is-fluid">
     <div class="level mb-4">
			<div class="level-left">
				<h1 class="title">List Governing Body Users</h1>
			</div>
			<div class="level-right">
				<div class="buttons">
				<a :href="'mailto:' + this.$auth.user.email + '?bcc=' + emailList" target="_blank" class="button is-link ">Compose Email To All</a>
				
				</div>
			</div>
		</div>
      <div class="box" v-if="governingBodies.length > 0">	
     <table class="table is-hoverable is-fullwidth">
    	<thead>
    		<th>Name</th>
        <th>Applications</th>
   	 		<th>Endorsed</th>
   	 		<th>Not Endorsed</th>
          
                <th>Outstanding</th>
                <th>Awarded</th>
          <th>Users</th>
          
    	</thead>
    	<tbody>
		    <tr v-for="row in governingBodies" :key="row.id"  >
				<td>{{row.name}}</td>
				<td>{{ ngbtotal[row.id] }}</td>
				<td>{{ ngbendorsed[row.id] }}</td>
        <td>{{ ngbnotendorsed[row.id] }}</td>
        <td>{{ ngboutstanding[row.id] }}</td>
         <td>{{ ngbawarded[row.id] }}</td>
        <td>
            <span v-for="item in row.users" :key="item.id" v-bind:class="getEmailClass(item)" >{{ item.email }} <br /></span>

        </td>
        
			</tr>
      
    	</tbody>
    </table>
    </div>
    
    

  </div>
</template>

<script>


import ApplicationService from '@/services/ApplicationService.js';

export default {
  components: {
   	
  },
  data() {
    return {
      orders: [],
      errors: [],
      governingBodies: [],
      applications: [],
      roundId:process.env.VUE_APP_CURRENT_ROUND_ID,
    }
  },


  // Fetches posts when the component is created.
  created() {
    this.getAccessToken()
    .then(() => { 
      this.getGoverningBodiesWithUsers();
    
      this.getApplications();
    });
   
  },
  watch: {
    '$route'() {
     this.getGoverningBodiesWithUsers();
    }
  },
  computed: {
    emailList: function () {
      let thisList = ''

      for (let i = 0; i < this.governingBodies.length; i++) {
          var users = this.governingBodies[i].users
          
          if(users.map(item => item.email).join(';') != '')
          {
              thisList = thisList + ';' + users.map(item => item.email).join(';')
          }
      }

      return thisList
    },
 
      ngbtotal: function() {
          var returnarray = []
          
          for (let i = 0; i < this.applications.length; i++) {
                var governing_body_id = this.applications[i].governing_body_id
                
                if(typeof returnarray[governing_body_id] === 'undefined') {
                    returnarray[governing_body_id] = 1
                }
                else {
                    returnarray[governing_body_id]++
                }
               
            }
          return returnarray
      },
      ngbendorsed: function() {
          var returnarray = []
          
          for (let i = 0; i < this.applications.length; i++) {
                if(this.applications[i].endorsed === 1)
                {
                    var governing_body_id = this.applications[i].governing_body_id
                    
                    if(typeof returnarray[governing_body_id] === 'undefined') {
                        returnarray[governing_body_id] = 1
                    }
                    else {
                        returnarray[governing_body_id]++
                    }
                }
            }
          return returnarray
      },
      ngbnotendorsed: function() {
          var returnarray = []
          
          for (let i = 0; i < this.applications.length; i++) {
                if(this.applications[i].endorsed === 2)
                {
                    var governing_body_id = this.applications[i].governing_body_id
                    
                    if(typeof returnarray[governing_body_id] === 'undefined') {
                        returnarray[governing_body_id] = 1
                    }
                    else {
                        returnarray[governing_body_id]++
                    }
                }
            }
          return returnarray
      },
      ngboutstanding: function() {
          var returnarray = []
          
          for (let i = 0; i < this.applications.length; i++) {
                if(this.applications[i].endorsed === 0)
                {
                    var governing_body_id = this.applications[i].governing_body_id
                    
                    if(typeof returnarray[governing_body_id] === 'undefined') {
                        returnarray[governing_body_id] = 1
                    }
                    else {
                        returnarray[governing_body_id]++
                    }
                }
            }
          return returnarray
      },
      ngbawarded: function() {
          var returnarray = []
          
          for (let i = 0; i < this.applications.length; i++) {
                if(this.applications[i].awarded === 1)
                {
                    var governing_body_id = this.applications[i].governing_body_id
                    
                    if(typeof returnarray[governing_body_id] === 'undefined') {
                        returnarray[governing_body_id] = 1
                    }
                    else {
                        returnarray[governing_body_id]++
                    }
                }
            }
          return returnarray
      }
  },
  methods: {
    async getAccessToken() {
      this.accessToken = await this.$auth.getTokenSilently()
    },
    async getGoverningBodiesWithUsers() {
      
     
      ApplicationService.getGoverningBodiesWithUsers(this.accessToken)
      .then(
        (governingBodies => {
          this.$set(this, "governingBodies", governingBodies);
        }).bind(this)
      );
    },
     async getApplications() {
      
      var status = ""
      if(this.$route.params.status != "" && this.$route.params.status != undefined)
      {
         status = this.$route.params.status 
      }

      // Use the eventService to call the getEventSingle() method
      ApplicationService.getApplications(this.accessToken, status, this.governingBodyId, "", "", this.roundId)
      .then(
        (applications => {
          this.$set(this, "applications", applications);
        }).bind(this)
      );
    },
    showStatus(endorsed, awarded)
    {
      var application_status = "New"
      if(awarded == 1)
      {
        application_status = "Awarded"
      }
      else if(awarded == 2)
      {
        application_status = "Not Awarded"
      }
      else if(endorsed == 1)
      {
        application_status = "Endorsed"
      }
      else if(endorsed == 2)
      {
        application_status = "Not Endorsed"
      }
      
      return application_status
    },
    getEmailClass(user)
    {
        console.log(user)
        if(user.logins_count > 0)
        {
            return 'has-text-success'
        }
        else if(user.email_verified == 1)
        {
            return 'has-text-warning-dark'
        }
        else{
            return 'has-text-danger'
        }
    }
  }
}

</script>

<style>
	
</style>
